/**
 * Default brand appearance values for the tenant branding system (DEV-48214).
 *
 * These defaults are chosen to be visually identical to the current live app so
 * existing tenants see no change on deploy. They are used both by
 * `applyBrandColors()` as fallback when a per-tenant field is null, and by the
 * Settings > Branding tab's "Reset to Defaults" button.
 *
 * DO NOT change these to the mockup's Octopus values (`#180048`, `#F0FFFF`,
 * `#F050F8`, `#382E55`) — those are demo values only. If we shipped those as
 * defaults every existing tenant would suddenly turn dark purple on deploy.
 *
 * `BUTTON_TEXT_COLOR` is intentionally null — the frontend auto-derives it
 * from `primary_color` luminance via `getContrastText()` when not overridden,
 * matching today's behaviour.
 */
export const DEFAULT_BRANDING = {
  /** Nav / sidebar background. Matches today's `bg-white`. */
  NAV_BACKGROUND_COLOR: '#FFFFFF',
  /** Nav / sidebar text. Matches today's `text-gray-700`. */
  NAV_TEXT_COLOR: '#374151',
  /**
   * Button text colour. `null` means: auto-derive from `primary_color` via
   * `getContrastText()`. Matches today's behaviour.
   */
  BUTTON_TEXT_COLOR: null as string | null,
  /**
   * Button/accent background. Matches the current model default. Existing
   * tenants that have overridden this keep their value.
   */
  PRIMARY_COLOR: '#1f2937',
} as const
